module.exports = __webpack_public_path__ + "img/btn-play-store-170.c73c96a4.png";